"use client";

export {
  matchesMobileViewport,
  MOBILE_VIEWPORT_MEDIA_QUERY,
  useMobileViewport as useIsMobile,
} from "@/lib/use-mobile-viewport";
